import React, {useState} from 'react'
import Container from '../Container'
import { Link } from 'react-router-dom'
import Button from '../Button'
import UploadModal from '../modal/UploadModal'
import Dropdown from "../../assets/svgs/dropdown.svg"



const Uploaded = () => {

    const [isUploadModalOpen, setUploadModalOpen] = useState(false)
    const toggleUploadModal = () => {
      setUploadModalOpen(!isUploadModalOpen)
    }
  return (
    <Container>
        <UploadModal 
      isOpen = {isUploadModalOpen} 
      onClose={toggleUploadModal} 
    />
        <div className='grid  h-[inherit] w-[inherit] font-poppins'>
            <div>
            <div className='w-[100%] bg-main-blue h-[20%]   rounded-2xl grid grid-cols-[80%_20%]'>
            <div className='flex flex-col justify-center pl-10 text-white'>
                        <h1 className='mb-3 flex text-2xl '>
                            Certificate and CV Review    
                        </h1>
                        <div className='flex gap-24'>
                        <Link to = "/uploaded" className='pt-8 text-sm font-normal'>Upload Documents</Link>
                        <Link to = "/saved" className='pt-8 text-sm font-normal' >Saved Documents</Link>
                    </div>
                    </div>
                    </div>
                    <div className='flex flex-col mt-[1rem] rounded-[1rem] bg-green-100'>
                    <div className='flex  gap-[24rem] p-[2rem] '>
                        <p className='text-sm'>Chinonye Lydia Umeh Resume</p>
                        <p className='text-red-500 text-sm pl-[10px]'>Replace Document</p>
                    </div>
                    
                        <div className='flex flex-col items-center justify-center'>
                        <hr className='flex flex-col items-center justify-center  w-[96%]' />
                        </div>
                    <div className='flex  gap-[23rem] p-[2rem] '>
                        <p className='text-sm'>Choose your industry of interest</p>
                        <div className='flex gap-24 rounded-[1rem] w-[12rem] bg-white p-[10px]'>
                        <p className='text-sm'>Select</p>
                        <img  src={Dropdown} alt="" />
                        </div>
                        
                    </div>
                    <div className='flex flex-col items-center justify-center'>
                        <hr className='flex flex-col items-center justify-center  w-[96%]' />
                        </div>
                    <div className='flex  gap-[24rem] p-[2rem] '>
                        <p className='text-sm'>Choose your prefered job role</p>
                        <div className='flex gap-24 rounded-[1rem] w-[12rem] bg-white p-[10px]'>
                        <p className='text-sm'>Select</p>
                        <img src={Dropdown} alt="" />
                        </div>
                    </div>
                    <div className='flex flex-col items-center justify-center'>
                        <hr className='flex flex-col items-center justify-center  w-[96%]' />
                        </div>
                    <div className=' flex flex-col items-center justify-center'>
                    <Button>
                        Review Document
                    </Button>
                    <p  className='mb-[1rem] text-sm mt-[1rem]'>Draft cover letter or resume instead ? <a href="/" className='text-red-500 '>click here</a></p>
                    </div>
                    </div>
            </div>
        </div>
    </Container>
  )
}

export default Uploaded